import { Localization } from '@/localization';
import { result } from 'lodash';
import _Vue from 'vue';

declare module 'vue/types/vue' {
    interface Vue {
        $l: Localization;
    }
  }

function setHandler(currentKey: Array<string> = []) {
    return {
        get(target: any, key: string, receiver: any): string | boolean {

            const prop = Reflect.get(target, key, receiver);
            if (key === 'subscribers' || typeof prop === 'symbol') {
                return prop;
            }
            const parentKey = [...currentKey];
            if (key === 'isProxy') {
                return true;
            }
            if (typeof prop === 'undefined') {
                parentKey.push(key.toString());
                return new Proxy({
                    str: parentKey.join('.'),
                    toString() { return this.str; },
                    get [Symbol.toStringTag]() {
                        return 'ProxyUndefined';
                    },
                    [Symbol.toPrimitive](hint: any) {
                        return this.str;
                    }
                }, setHandler(parentKey));
            }

            if (!prop.isProxy && typeof prop === 'object') {
                parentKey.push(key);
                return new Proxy(prop, setHandler(parentKey));
            }

            if (prop === '') {
                parentKey.push(key.toString());
                return parentKey.join('.');
            }

            return prop;
        }
    };
}

export function LocalizationPlugin(Vue: any) {
    const localization = new Localization();
    const localizationProxy = new Proxy(localization, setHandler(['$l']));
    Object.defineProperties(Vue.prototype, {
        $l : {
            get() { return localizationProxy; }
        }
    });
    Vue.mixin({
        created() {
            this.$l.subscribeDataChanging(this);
        },
        destroyed() {
            this.$l.unsubscribeDataChanging(this);
        }
    });
}
